import { Attributes, ModelBase, Validation, ValueObject } from '@singularsystems/neo-core';
import { TradeOrderStatus } from '../Enums/TradeOrderStatus';

export default class UpdateTradeOrderCommand extends ModelBase {

    constructor() {
        super();
        this.makeObservable();
    }

    public tradeOrderId: number = 0;

    @Attributes.Nullable()
    @Attributes.Float()
    public amount: number | null = null;

    @Attributes.Nullable()
    @Attributes.Float()
    public confirmedAmount: number | null = null;

    public tradeOrderStatus: TradeOrderStatus  | null = null;

    public note: string = "";

    public isSent: boolean = false;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Update Trade Order Command";
    }
}